// document.addEventListener('DOMContentLoaded', function () {
//   document.querySelectorAll('select[name="product-promo-variant-block"]').forEach(function (selectEl) {
//     selectEl.addEventListener('change', function () {
//       const selectedVariantId = this.value;
//       const productContainer = this.closest('.product-promo-content-block');
//       const hiddenInput = productContainer.querySelector('input[name="id"]');
//       if (hiddenInput) {
//         hiddenInput.value = selectedVariantId;
//       }
//     });
//   });

//   document.querySelectorAll('form.product-single__form').forEach(function (form) {
//     form.addEventListener('submit', function (e) {
//       e.preventDefault();

//       const variantId = form.querySelector('input[name="id"]')?.value;
//       if (!variantId) {
//         return;
//       }

//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json'
//         },
//         body: JSON.stringify({
//           id: variantId,
//           quantity: 1
//         })
//       })
//         .then(res => {
//           if (!res.ok) throw new Error('Add to cart failed');
//           return res.json();
//         })
//         .then(data => {

//           const cartDrawerBtn = document.querySelector('.js-drawer-open-cart');
//           if (cartDrawerBtn) {
//             cartDrawerBtn.dispatchEvent(new Event('click', { bubbles: true }));
//           }
//         })
//         .catch(error => {
//           console.error(error);
//         });
//     });
//   });

// });

//Yash Code


// document.addEventListener('DOMContentLoaded', function() {
//   // Listen for all Add to Cart forms inside promo block
//   document.querySelectorAll('.product-promo-block form[action*="/cart/add"]').forEach((form) => {
//     form.addEventListener('submit', function(e) {
//       e.preventDefault();
//       const formData = new FormData(form);
//       const submitBtn = form.querySelector('button[type="submit"]');
//       submitBtn.classList.add('loading');

//       fetch('/cart/add.js', {
//         method: 'POST',
//         body: formData,
//         headers: {
//           'X-Requested-With': 'XMLHttpRequest'
//         }
//       })
//       .then(response => {
//         if (!response.ok) throw new Error('Add to cart failed');
//         return response.json();
//       })
//       .then((data) => {
//         // ✅ Product successfully added to cart
//         submitBtn.classList.remove('loading');
//         submitBtn.innerHTML = 'Added ✓';

//         // Wait a moment for UX feedback, then refresh the page
//         setTimeout(() => {
//           window.location.reload(); // 🔁 refresh page to update drawer/cart
//         }, 500); // half-second delay for smoother effect
//       })
//       .catch((error) => {
//         console.error('Error adding to cart:', error);
//         submitBtn.classList.remove('loading');
//         alert('Sorry, something went wrong. Please try again.');
//       });
//     });
//   });

//   // Update hidden variant ID when user selects a variant
//   document.querySelectorAll('#product-promo-variant').forEach(select => {
//     select.addEventListener('change', function() {
//       const variantId = this.value;
//       const form = this.closest('form');
//       if (form) {
//         form.querySelector('input[name="id"]').value = variantId;
//       }
//     });
//   });
// });


document.addEventListener('DOMContentLoaded', function() {
  // --- Add to cart logic ---
  document.querySelectorAll('.product-promo-block form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const formData = new FormData(form);
      const submitBtn = form.querySelector('button[type="submit"]');
      submitBtn.classList.add('loading');

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(response => {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(() => {
        submitBtn.classList.remove('loading');
        submitBtn.innerHTML = 'Added ✓';
        setTimeout(() => window.location.reload(), 500); // refresh for drawer
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        submitBtn.classList.remove('loading');
        alert('Sorry, something went wrong. Please try again.');
      });
    });
  });

  // --- Variant change logic ---
  document.querySelectorAll('.product-promo').forEach(select => {
    select.addEventListener('change', function() {
      const variantId = this.value;
      // Find the closest promo block
      const promoBlock = this.closest('.product-promo-sub-block');
      if (!promoBlock) return;

      // Find the corresponding form and update its hidden input
      const form = promoBlock.querySelector('form[action*="/cart/add"]');
      const hiddenInput = form ? form.querySelector('input[name="id"]') : null;
      if (hiddenInput) hiddenInput.value = variantId;
    });
  });
});


